/*
(C)2020 Sergio A. Fernandez, Ph.D.
*/


export interface TrainingState {
  play: any
  task_index: number
  scene_index: number
  act: string //steps, describe, problems
  mime_type: string,
  mime_ext: string,
  roll: string

  curr_time: number
  pause: number,
  play_it: number,
  rec_count: number,
  other_rec_count: number,
  stop: number,

  sketch_index: number
  last_sketch: any
  save_play: any

  user: any
  progress: any
  del_movies: any

  patients: any

  set_segment: any,

  zoom: number,
  remote_zoom_pan: any,

}

export const initialTrainingState: TrainingState = {
  play: {},
  task_index: -1,
  scene_index: -1,
  act: "intro",
  mime_type: "video/webm",
  mime_ext: ".webm",
  roll: "",

  curr_time: 0,
  pause: 0,
  play_it: 0,
  rec_count: 0,
  other_rec_count: 0,
  stop: 0,
  sketch_index: -1,
  last_sketch: undefined,

  save_play: undefined,
  user: {},
  progress: {},
  del_movies: {},


  patients: undefined,
  set_segment: {},
  zoom: 1,
  remote_zoom_pan: undefined,

};
